import { homeServerUrl } from "../environment/Environment";
import axiosInstance from "../external-library/axios-interceptor/Interceptor";
import qs from "qs";

const getAllCtegory = async (countryName) => {
  return await axiosInstance.get(`${homeServerUrl}/WasteCategory`, {
    params: { countryName },
  });
};

const getWasteCategoriesWithTypesAndModels = async (countryName) => {
  return await axiosInstance.get(`${homeServerUrl}/WasteCategory`, {
    params: { countryName },
  });
};

const getAllBusinessModel = async () => {
  return await axiosInstance.get(`${homeServerUrl}/BusinessModel`);
};

const getAllValueAddedProducts = async () => {
  return await axiosInstance.get(`${homeServerUrl}/ValueAddedProduct/all`);
};

const getBusinessModelByValueAddedProducts = async (
  selectedWasteCategory,
  selectedValueAddedProduct,
  businessModelList,
  selectedWasteType
) => {
  //console.log(businessModelList);
  return await axiosInstance.get(`${homeServerUrl}/ValueAddedProduct`, {
    params: {
      valueAddedProduct: selectedValueAddedProduct,
      wasteCategory: selectedWasteCategory,
      wasteCategoryBusinessModels: businessModelList,
      wasteType: selectedWasteType,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
};

const addWasteQualification = async (wasteQualificationDetails) => {
  return await axiosInstance.post(
    `${homeServerUrl}/ERP`,
    wasteQualificationDetails
  );
};

const getTruckCapacity = async () => {
  return await axiosInstance.get(`${homeServerUrl}/Transpotation`);
};

const addBusinessModelwithWasteQualification = async (id, businessModelId) => {
  return await axiosInstance.put(`${homeServerUrl}/ERP/${id}`, {
    businessModelId,
  });
};

const getSenarioDetails = async (detailsOfErp) => {
  return await axiosInstance.get(`${homeServerUrl}/ERP/GetAll`, {
    params: {
      id: detailsOfErp.mapPointId,
      businessScenarioId: detailsOfErp.businessScenarioId,
    },
  });
};

const calculateNpv = async (detailsOfErp, id) => {
  return await axiosInstance.put(
    `${homeServerUrl}/MapPoint/npv`,
    detailsOfErp,
    {
      params: {
        location: id,
      },
    }
  );
};

const allCalculation = async (payLoad) => {
  return await axiosInstance.post(`${homeServerUrl}/Calculation`, payLoad, {
    params: {
      businessScenarioId: payLoad?.businessScenarioId,
    },
  });
};

const getExpectedLifeOfPlants = async () => {
  return await axiosInstance.get(`${homeServerUrl}/ExpectedLifeOfPlants`);
};

const getRRRObjective = async () => {
  return await axiosInstance.get(`${homeServerUrl}/RRRObjective`);
};

const downloadReportData = async (detailsForReport) => {
  const formData = new FormData();
  // ✅ Append files (ensure they are File objects)
  formData.append("mapImage", detailsForReport.mapImage); // File object
  formData.append("graphImage", detailsForReport.graphImage); // File object
  return await axiosInstance.post(
    `${homeServerUrl}/reports/DownloadReport`,
    formData,
    {
      params: {
        mapPointId: detailsForReport.mapPointId,
        businessScenarioId: detailsForReport.businessScenarioId,
        // calculationTableId: detailsForReport.calculationTableId,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    }
  );
};

const mcdaCalculation = async (details) => {
  return await axiosInstance.post(`${homeServerUrl}/McdaNew/save`, null, {
    params: {
      businessScenarioId: details.businessScenarioId,
      rrrObjectiveId: details.rrrObjectiveId,
    },
  });
};

/**ALL NEW CHANGE API FOR **/

const addNewBusinessSenarioForWithMapPoint = async (payload) => {
  return await axiosInstance.post(
    `${homeServerUrl}/ErpCalculationCombine`,
    payload
  );
};


const downloadGossaryPdf = async () => {
  return await axiosInstance.get(`${homeServerUrl}/Glossary/download`, {
    responseType: "arraybuffer", // Important for binary data
  });
};

const getMCDAResults = async (payload) => {
  return await axiosInstance.post(`${homeServerUrl}/analysis`, payload);
};
const postMCDAResults = async (payload) => {
  return await axiosInstance.post(`${homeServerUrl}/post-healthcheck`, payload);
};

const saveAnalysis = async (payload) => {
  return await axiosInstance.post(`${homeServerUrl}/save-analysis`, payload);
};

const downloadReport = async (currentPayload) => {
  return await axiosInstance.post(`${homeServerUrl}/report`, currentPayload, {
    responseType: "blob",
  });
};

const getAnalysis = async (payload) => {
  return await axiosInstance.get(`${homeServerUrl}/analyses`, {
    params: payload
  });
};



export {
  getAllCtegory,
  getWasteCategoriesWithTypesAndModels,
  getAllBusinessModel,
  getAllValueAddedProducts,
  addWasteQualification,
  getSenarioDetails,
  addBusinessModelwithWasteQualification,
  calculateNpv,
  getTruckCapacity,
  allCalculation,
  getBusinessModelByValueAddedProducts,
  getExpectedLifeOfPlants,
  getRRRObjective,
  downloadReportData,
  mcdaCalculation,
  /**new api**/
  addNewBusinessSenarioForWithMapPoint,
  downloadGossaryPdf,
  getMCDAResults,
  postMCDAResults,
  saveAnalysis,
  getAnalysis,
  downloadReport
};
